import React, { useState, FormEvent, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../api';
import Navbar from '../components/Header/Navbar';
import Button from '../components/Button';
import { readFriendlyApiErrorMessage } from '../utils/apiErrorMessages';

const Giris: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [registrationSuccess, setRegistrationSuccess] = useState<boolean>(false);
  const [passwordResetSuccess, setPasswordResetSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const state = location.state as {
      fromRegistration?: boolean;
      fromForgotPassword?: boolean;
      sessionEndedMessage?: string;
    } | undefined;
    if (state?.fromRegistration) {
      setRegistrationSuccess(true);
      setError('');
      window.history.replaceState({}, document.title, location.pathname);
    }
    if (state?.fromForgotPassword) {
      setPasswordResetSuccess(true);
      setError('');
      window.history.replaceState({}, document.title, location.pathname);
    }
    if (state?.sessionEndedMessage) {
      setError(state.sessionEndedMessage);
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location.state, location.pathname]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError('');
    setRegistrationSuccess(false);

    if (!email || !password) {
      setError('Lütfen tüm alanları doldurun!');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      if (rememberMe) {
        localStorage.setItem('rememberedEmail', email);
      }
    } catch (err) {
      setError(readFriendlyApiErrorMessage(err, 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.'));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = (): void => {
    window.location.href = authService.getGoogleLoginUrl();
  };

  return (
    <>
      <Navbar />
      <div className="sb-page-bg min-vh-100 d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <div className="card shadow-sm">
                <div className="card-body p-4">
                  <h4 className="card-title text-center mb-4">
                    Giriş Yap
                  </h4>

                {registrationSuccess && (
                  <div className="alert alert-info mb-3" role="alert">
                    E-posta aktivasyon kodunuz e-posta adresinize gönderildi.
                  </div>
                )}

                {passwordResetSuccess && (
                  <div className="alert alert-success mb-3" role="alert">
                    Şifreniz başarıyla güncellendi. Giriş yapabilirsiniz.
                  </div>
                )}

                {error && (
                  <div className="alert alert-danger mb-3" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">
                      E-posta
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">
                      Şifre
                    </label>
                    <input
                      className="form-control"
                      type="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="text-end mt-1">
                      <Link className="text-decoration-none small" to="/sifremi-unuttum">
                        Şifremi Unuttum
                      </Link>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <label className="form-check-label">
                        Beni Hatırla
                      </label>
                    </div>
                  </div>
                  <Button className="btn btn-primary w-100 mb-3" type="submit" loading={loading}>
                    Giriş Yap
                  </Button>
                  <div className="text-center mb-3">
                    <span className="text-muted">
                      veya
                    </span>
                  </div>
                  <Button
                    className="btn sb-oauth-google-btn w-100 mb-3"
                    type="button"
                    onClick={handleGoogleLogin}
                  >
                    <i className="fab fa-google me-2" style={{ fontSize: '1.1rem' }} aria-hidden />
                    Google ile Giriş Yap
                  </Button>
                  <div className="text-center">
                    <span className="text-muted">
                      Hesabınız yok mu?
                    </span>
                    <Link className="text-decoration-none" to="/kayit">
                      Kayıt Ol
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Giris;
